import { Users, FileText, MessageSquare, TrendingUp } from 'lucide-react';
import StatsGrid from './StatsGrid';
import ActivityList from './ActivityList';
import { LoadingState } from '../common';
import MonthlyActivityChart from './MonthlyActivityChart';
import { useDashboardData } from './hooks';
import storage from '../../utils/storage';
import { useState } from 'react';
import { Button } from '../ui';

export default function AdminDashboard() {
    const { data, loading, error } = useDashboardData();
    const [showAllActivities, setShowAllActivities] = useState(false);

    // Récupérer le nom de l'utilisateur connecté
    const user = storage.getUser();
    const userName = user?.first_name || user?.name || user?.username || 'Administrateur';

    if (loading) {
        return <LoadingState message="Chargement du tableau de bord..." />;
    }

    if (error) {
        return (
            <div className="flex items-center justify-center py-12">
                <div className="text-center">
                    <p className="text-red-600 mb-4">{error}</p>
                </div>
            </div>
        );
    }

    const kpis = data.kpis || {};
    const users = kpis.users || {};
    const surveys = kpis.surveys || {};
    const participants = kpis.participants || {};
    const responses = kpis.reponses || {};

    // Récupérer les activités
    const allActivities = data?.recent_activities?.results || data?.recent_activities || [];
    const displayedActivities = showAllActivities ? allActivities : allActivities.slice(0, 3);

    // Préparer les statistiques
    const stats = [
        {
            icon: Users,
            label: 'Utilisateurs',
            value: users?.total || 0,
            change: data?.users_change || '+0',
            changeType: 'positive',
            variant: "primary",
            details: `${users.actifs || 0} actifs`
        },
        {
            icon: FileText,
            label: 'Sondages total',
            value: surveys?.total || 0,
            change: data?.surveys_change || '+0',
            changeType: 'positive',
            variant: "accent",
            details: `${surveys.actifs || 0} actifs`,
        },
        {
            icon: MessageSquare,
            label: 'Réponses totales',
            value: responses?.total || 0,
            change: data?.responses_change || '+0',
            changeType: 'positive',
            variant: "success",
            details: `${participants.taux_participation || 0}% participation`
        },
        {
            icon: TrendingUp,
            label: 'Taux participation',
            value: `${participants?.total || 0}%`,
            change: data?.participation_change || '+0%',
            changeType: 'positive',
            variant: "primary",
            details: 'Collectées',
        },
    ];

    return (
        <div className="space-y-6">
            {/* Header */}
            <div className="">
                <h1 className="text-lg font-semibold text-[#009688]">Bonjour <span className='lowercase'>{userName}</span> !</h1>
                <p className="text-gray-600 mt-1 text-sm">Voici un aperçu de votre plateforme de sondages</p>
            </div>

            {/* Statistiques */}
            <StatsGrid stats={stats} />

            {/* Graphiques et Activités */}
            <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
                {/* Graphique Mensuel */}
                <div className="lg:col-span-2">
                    <MonthlyActivityChart monthlyTrend={data?.monthly_trend} />
                </div>

                {/* Activité Récente */}
                <div className="space-y-4">
                    <ActivityList
                        activities={displayedActivities}
                        title="Activité récente"
                    />
                    {allActivities.length > 4 && (
                        <Button 
                            variant="outline" 
                            className="w-full"
                            onClick={() => setShowAllActivities(!showAllActivities)}
                        >
                            {showAllActivities ? 'Afficher moins' : `Voir plus (${allActivities.length - 5})`}
                        </Button>
                    )}
                </div>
            </div>
        </div>
    );
}
